// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__23LI9","inputWrap":"styles_inputWrap__267Uv","input":"styles_input__2oiLT"};